
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"fill":"none","height":"24","viewBox":"0 0 24 24","width":"24","xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink"}, attrs),
              ...rest,
            },
            children.concat([_c('clipPath',{attrs:{"id":"a"}},[_c('path',{attrs:{"d":"m0 0h24v24h-24z"}})]),_c('g',{attrs:{"clip-path":"url(#a)"}},[_c('path',{attrs:{"d":"m12.0262 3c3.0768 0 5.5799 2.37913 5.5799 5.30362 0 1.98278-1.1476 3.71718-2.8158 4.60978 3.3895 1.0409 5.8926 3.8663 6.2053 7.3854.1042.8919-1.6689.9418-1.7207.0991-.3653-3.5191-3.5462-6.1955-7.2486-6.1955-3.7549 0-6.88338 2.6764-7.24871 6.1955-.10426.8427-1.87743.7928-1.77317-.0991.36528-3.4698 2.8682-6.3445 6.20528-7.3854-1.6689-.8918-2.81576-2.6272-2.81576-4.60978 0-2.92449 2.55548-5.30362 5.63226-5.30362zm0 1.68538c-2.13769 0-3.85914 1.63548-3.85914 3.61809 0 2.03193 1.72065 3.66813 3.85914 3.66813 2.086 0 3.8065-1.6355 3.8065-3.66813 0-1.98276-1.7206-3.61809-3.8065-3.61809z","fill":"#4a3428"}}),_c('path',{attrs:{"d":"m18.8051 2.43733-.9421.94213-.319-.32413-.0028-.00277c-.2468-.24885-.5404-.44636-.864-.58114-.3235-.13479-.6705-.20418-1.021-.20418s-.6975.06939-1.021.20418c-.3234.13473-.6169.33213-.8636.58082-.4942.49739-.7716 1.17007-.7716 1.87124 0 .70139.2775 1.37428.772 1.87171l.0021.00211 2.2176 2.21759.0021.0021c.4975.49448 1.1704.77203 1.8717.77203.7014 0 1.3743-.27755 1.8718-.77203l.0021-.0021 4.4019-4.4019c.2578-.23686.4663-.52244.6133-.84036.1513-.32699.2345-.68135.2444-1.0415s-.0535-.71855-.1866-1.05338c-.1328-.33444-.3323-.63837-.5862-.893338-.2466-.248412-.5399-.445606-.8631-.58023-.3235-.1347865-.6705-.204182-1.021-.204182s-.6975.0693957-1.021.204182c-.3229.134497-.6159.331447-.8624.579529z","fill":"#ee6054","stroke":"#fff","stroke-width":"2"}})])])
          )
        }
      }
    